import {css} from 'lit'; export default css`:host{display:inline-block}.sds-action-list{display:flex;gap:2px}.sds-action-list sds-tooltip{display:inline-block}`;
    